import React from 'react';
import DashboardIncomeChart from '../../components/DashboardIncomeChart';
import '../../style.css';
import DashboardCarChart from '../../components/DashboardCarChart';
import { useDashboardContext } from '../../context/DashboardContext';

const Home = () => {
  const { hasIncome } = useDashboardContext();
  return (
    <div>
      <div className="dashboard-container" >
        <div className="chart" >
              {hasIncome ? <DashboardIncomeChart /> : null}
        </div>
      </div>
        <div>
          <DashboardCarChart />
        </div>
    </div>
  );
};

export default Home;
